export default function EmptyState({ icon, title, message }) {
  return (
    <div className="flex flex-col items-center justify-center py-16 text-center" data-testid="empty-state">
      {icon && <div className="text-4xl mb-4">{icon}</div>}
      <h3 className="text-lg font-bold font-syne text-[#E2E8F0] mb-2">{title}</h3>
      <p className="text-sm text-[#94A3B8] max-w-sm">{message}</p>
    </div>
  );
}
